import { render, staticRenderFns } from "./LuExciseIssuesDialog.vue?vue&type=template&id=325e5617&"
import script from "./LuExciseIssuesDialog.vue?vue&type=script&lang=js&"
export * from "./LuExciseIssuesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports